export default __webpack_public_path__ + "static/media/leftBorder.35634fca.svg";